import { render, staticRenderFns } from "./deck-connect-passage.vue?vue&type=template&id=afccbb6a"
import script from "./deck-connect-passage.vue?vue&type=script&lang=js"
export * from "./deck-connect-passage.vue?vue&type=script&lang=js"
import style0 from "./deck-connect-passage.vue?vue&type=style&index=0&id=afccbb6a&prod&lang=less&rel=stylesheet%2Fless"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports